import { useContext, useState } from "react";
import { icons } from "../../../../stack/environment/icons/iconExport";
import { FieldsSettingsContext } from "../../CustomNotificationPage";
import { field_IDs_mapping } from "../../fieldMapping";
import SettingsList from "../components/SettingsList";
import SettingsSection from "../components/SettingsSection";

export default function IntegrationsNotificationsSection() {
  const [fetchStatus, setFetchStatus] = useState(null);
  const getSectionSettingsData = useContext(FieldsSettingsContext);

  const settingsFields = Object.values(field_IDs_mapping.INTEGRATIONS);

  const settingsData = getSectionSettingsData(settingsFields);

  return (
    <SettingsSection
      title="Integrations"
      Icon={icons.IntegrationsIcon}
      fetchStatus={fetchStatus}
      setFetchStatus={setFetchStatus}
    >
      <SettingsList
        settingsData={settingsData}
        setFetchStatus={setFetchStatus}
      />
    </SettingsSection>
  );
}
